import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Routes } from 'react-router-dom';
import { pagesJSX } from './pages/pages';
import Navbar from './components/navbar';
import Footer from './components/footer';
import { Col, RefreshOnNavigate } from './components/custom';

import socket from './socket';

import './scss/global.scss';

import './scss/landing.scss';

import './scss/solutions/employeeExp.scss';
import './scss/solutions/customerExp.scss';
import './scss/solutions/secondaryRes.scss';

import './scss/usecase.scss';

import './scss/sample/EJI.scss';
import './scss/sample/CX.scss';
import './scss/sample/MII.scss';

import './scss/perspective.scss';

import './scss/pricing.scss';

import './scss/contact.scss';

import './scss/tool.scss';
import './scss/test.scss';

ReactDOM.createRoot(document.body).render(
    // <React.StrictMode>
        <BrowserRouter>
            <RefreshOnNavigate/>
            <Navbar/>
            <Col id = 'main'>
                <Routes>
                    {pagesJSX}
                </Routes>
            </Col>
            <Footer/>
        </BrowserRouter>
    // </React.StrictMode>
);

socket.connect();

reportWebVitals();